import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface OverlayCardProps {
  children: ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
}

const OverlayCard = ({ children, className, size = "md" }: OverlayCardProps) => {
  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "p-6 max-w-md";
      case "md":
        return "p-8 max-w-lg";
      case "lg":
        return "p-10 max-w-2xl";
      default:
        return "p-8 max-w-lg";
    }
  };

  return (
    <div className={cn(
      "bg-white/95 backdrop-blur-sm rounded-lg shadow-card",
      getSizeClass(),
      className
    )}>
      {children}
    </div>
  );
};

export default OverlayCard;